import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root',
})
export class ExcelService {

  getValueByPath(obj: any, path: string): any {
    const pathSegments = path.split('.');
    let current = obj;

    for (const segment of pathSegments) {
      if (Array.isArray(current)) {
        current = current
          .map((item) => (item && typeof item === 'object' ? item[segment] : undefined))
          .filter((val) => val !== undefined);
      } else if (current && typeof current === 'object' && segment in current) {
        current = current[segment];
      } else {
        return undefined;
      }
    }

    return Array.isArray(current) ? current.join(';') : current;
  }

  exportToExcel(
    data: any[],
    excelParameters: any[],
    fileName: string,
    sheetName: string = 'Sheet1'
  ) {
    const headers = excelParameters.map((param) => param.label);

    const mappedData = data.map((item) => {
      const row: any = {};

      for (const param of excelParameters) {
        const value = this.getValueByPath(item, param.value);

        let formattedValue = null;
        if (value === true) formattedValue = '+';
        else if (value === false) formattedValue = '-';
        else if (value !== undefined && value !== null) formattedValue = value;

        row[param.label] = formattedValue;
      }

      return row;
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(mappedData, {
      header: headers,
    });

    const workbook: XLSX.WorkBook = {
      Sheets: { [sheetName]: worksheet },
      SheetNames: [sheetName],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });

    this.saveAsExcelFile(excelBuffer, fileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string) {
    const data: Blob = new Blob([buffer], { type: 'application/octet-stream' });
    saveAs(data, `${fileName}.xlsx`);
  }

  async importFromExcel(file: File): Promise<any[]> {
    try {
      const arrayBuffer = await file.arrayBuffer(); // ✅ Sonar Uyarısı Düzeldi
      const data = new Uint8Array(arrayBuffer);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];

      const jsonData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
        defval: null,
        dateNF: 'yyyy/MM/dd',
        raw: false,
      });

      return jsonData;
    } catch (error) {
      throw error;
    }
  }
}
